import { Col } from '../grid';
import type { ColProps, ColSize } from '../grid';

export type { ColProps, ColSize };

export default Col;
